export default {
    I: {texto: 'Inserção', valor: 'I'},
    U: {texto: 'Atualização', valor: 'U'},
    D: {texto: 'Cancelamento', valor: 'D'}
}